import script from "./Timetable.vue?vue&type=script&setup=true&lang=js"
export * from "./Timetable.vue?vue&type=script&setup=true&lang=js"

import "./Timetable.vue?vue&type=style&index=0&id=64feead2&lang=scss"

const __exports__ = script;

export default __exports__